import React, { useState } from "react"
import { injectIntl } from "react-intl"
import { makeStyles } from "@material-ui/core/styles"
import ArrowForwardIcon from "@material-ui/icons/ArrowForward"
import { Box, Card, Grid, Typography } from "@material-ui/core"
import { Checkbox } from "@ridecell/web-components-material"

import LoadingButton from "../../LoadingButton"
import useGlobalContext from "../../../utils/customHooks/useGlobalContext"
import messages from "./messages"

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  card: {
    margin: "24px",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12)",
    borderRadius: "4px",
  },
  title: {
    fontSize: "20px",
    lineHeight: "32px",
    textAlign: "center",
  },
  subTitle: {
    fontSize: "16px",
    lineHeight: "28px",
    textAlign: "center",
  },
  checkboxText: {
    fontSize: "16px",
    lineHeight: "24px",
    color: "#616161",
  },
})

const ConsentOptions = ({
  intl: { formatMessage },
  options,
  handleNext,
  showNextButton = true,
}) => {
  const classes = useStyles()
  const {
    state: { consentAcceptedOptions, loading },
    setConsentAcceptedOptions,
  } = useGlobalContext()

  const onSubmit = () => {
    handleNext(consentAcceptedOptions)
  }

  return (
    <Grid item xs={12} md={12} lg={showNextButton ? 6 : 12}>
      <Card className={classes.card}>
        <Box display="flex" sx={{ mb: "16px" }} justifyContent="center">
          <Typography className={classes.title}>
            {formatMessage(messages.privacyTitle)}
          </Typography>
        </Box>
        <Box display="flex" sx={{ mb: "16px" }} justifyContent="center">
          <Typography>{formatMessage(messages.privacyMessage)}</Typography>
        </Box>
        {options.map((option) => {
          return (
            <Box display="flex">
              <Box display="flex" flexDirection="row">
                <Checkbox
                  size="medium"
                  name={`option-${option.id}`}
                  checked={consentAcceptedOptions.find((o) => o === option.id)}
                  onChange={(e) => {
                    if (consentAcceptedOptions.find((o) => o === option.id))
                      setConsentAcceptedOptions(
                        consentAcceptedOptions.filter((o) => o !== option.id)
                      )
                    else {
                      setConsentAcceptedOptions([
                        ...consentAcceptedOptions,
                        option.id,
                      ])
                    }
                  }}
                />
                <Box
                  display="flex"
                  justifyContent="center"
                  flexDirection="column"
                  alignContent="center"
                >
                  <Typography className={classes.checkboxText}>
                    {option.description}
                  </Typography>
                </Box>
              </Box>
            </Box>
          )
        })}
        {showNextButton && (
          <LoadingButton
            type="submit"
            text={formatMessage(messages.next)}
            loading={loading}
            onClick={onSubmit}
            props={{
              endIcon: <ArrowForwardIcon />,
              fullWidth: true,
              size: "large",
              variant: "contained",
            }}
          />
        )}
      </Card>
    </Grid>
  )
}

export default injectIntl(ConsentOptions)
